/* tslint:disable */

declare var Object: any;
export interface ObjectTypeHelpCardInterface {
  "helpCardTypeId": number;
  "objectTypeId": number;
  "name": string;
  "displayName"?: string;
  "active"?: boolean;
  "data": any;
  "order": number;
  "languageCode"?: any;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class ObjectTypeHelpCard implements ObjectTypeHelpCardInterface {
  "helpCardTypeId": number;
  "objectTypeId": number;
  "name": string;
  "displayName": string;
  "active": boolean;
  "data": any;
  "order": number;
  "languageCode": any;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: ObjectTypeHelpCardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObjectTypeHelpCard`.
   */
  public static getModelName() {
    return "ObjectTypeHelpCard";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObjectTypeHelpCard for dynamic purposes.
  **/
  public static factory(data: ObjectTypeHelpCardInterface): ObjectTypeHelpCard{
    return new ObjectTypeHelpCard(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ObjectTypeHelpCard',
      plural: 'ObjectTypeHelpCards',
      path: 'ObjectTypeHelpCards',
      idName: 'id',
      properties: {
        "helpCardTypeId": {
          name: 'helpCardTypeId',
          type: 'number'
        },
        "objectTypeId": {
          name: 'objectTypeId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "order": {
          name: 'order',
          type: 'number',
          default: 0
        },
        "languageCode": {
          name: 'languageCode',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
